// Auto-generated from lib/i18n.js (mechanical split — do not hand-reorder).
// Namespace "crud" base dictionary. New keys for feature batches go in sibling
// fragment files, merged in ./index.js — not here.
export default {
  "fr": {
      "programs.title": "Programmes",
      "programs.subtitle": "Créez et gérez vos programmes d'accompagnement payants.",
      "programs.new": "Nouveau programme",
      "programs.empty": "Aucun programme pour le moment.",
      "programs.field.name": "Nom du programme",
      "programs.field.tagline": "Sous-titre / accroche",
      "programs.field.description": "Description complète",
      "programs.field.price": "Prix (en centimes)",
      "programs.field.duration": "Durée (ex: 8 semaines)",
      "programs.field.image": "Image de couverture",
      "programs.field.features": "Inclus dans le programme",
      "programs.field.featured": "Mettre en avant",
      "programs.field.active": "Visible publiquement",
      "invoices.title": "Factures",
      "invoices.subtitle": "Créez une facture, envoyez le lien de paiement par courriel.",
      "invoices.new": "Nouvelle facture",
      "invoices.field.client_name": "Nom du client",
      "invoices.field.client_email": "Courriel du client",
      "invoices.field.amount": "Montant",
      "invoices.field.amountMajor": "Montant ({currency})",
      "invoices.field.description": "Description",
      "invoices.amountTooSmall": "Entrez un montant d'au moins {min} {currency}.",
      "invoices.willBill": "Facturera {amount}.",
      "invoices.willBillWithTax": "Facturera {amount} — {subtotal} plus {taxes}.",
      "invoices.willBillBeforeTax": "Facturera {amount} avant taxes.",
      "invoices.number.draft": "Brouillon",
      "invoices.receiptTag": "Reçu {number}",
      "invoices.status.refunded": "Remboursée",
      "invoices.status.overdue_notified": "En retard",
      "invoices.actions.cancel": "Annuler la facture",
      "invoices.confirmCancel": "Annuler la facture {number} ? Le lien de paiement sera désactivé. Le numéro reste attribué.",
      "invoices.confirmCancelDraft": "Annuler ce brouillon de facture ? Il ne pourra plus être envoyé.",
      "invoices.cancelled": "Facture annulée.",
      "invoices.error.notDeletable": "Une facture numérotée ne peut pas être supprimée. Annulez-la plutôt.",
      "invoices.error.notCancellable": "Cette facture est déjà payée, remboursée ou annulée.",
      "invoices.error.notSendable": "Cette facture a été payée ou annulée entre-temps.",
      "invoices.error.numberBusy": "Numérotation momentanément indisponible, réessayez.",
      "invoices.error.belowMinimum": "Un paiement par carte doit être d'au moins {min} {currency} : cette facture ne peut pas être envoyée. Supprimez-la et créez-en une d'au moins ce montant.",
      "invoices.error.paymentsUnavailable": "Le paiement en ligne n'est pas disponible pour le moment : la facture n'a pas été envoyée. Réessayez plus tard.",
      "invoices.error.descriptionTooLong": "La description dépasse {max} caractères : cette facture ne peut pas être envoyée. Supprimez-la et créez-en une avec une description plus courte.",
      "invoices.error.sentConcurrently": "Cette facture vient d'être envoyée depuis une autre fenêtre : seul ce lien de paiement est valide.",
      "invoices.actions.send": "Envoyer",
      "invoices.actions.copy_link": "Copier le lien",
      "invoices.status.draft": "Brouillon",
      "invoices.status.sent": "Envoyée",
      "invoices.status.paid": "Payée",
      "invoices.status.cancelled": "Annulée",
      "invoices.empty": "Aucune facture pour le moment."
  },
  "en": {
      "programs.title": "Programs",
      "programs.subtitle": "Create and manage your paid coaching programs.",
      "programs.new": "New program",
      "programs.empty": "No programs yet.",
      "programs.field.name": "Program name",
      "programs.field.tagline": "Subtitle / tagline",
      "programs.field.description": "Full description",
      "programs.field.price": "Price (in cents)",
      "programs.field.duration": "Duration (ex: 8 weeks)",
      "programs.field.image": "Cover image",
      "programs.field.features": "Included in the program",
      "programs.field.featured": "Feature this program",
      "programs.field.active": "Publicly visible",
      "invoices.title": "Invoices",
      "invoices.subtitle": "Create an invoice, email a Stripe payment link.",
      "invoices.new": "New invoice",
      "invoices.field.client_name": "Client name",
      "invoices.field.client_email": "Client email",
      "invoices.field.amount": "Amount",
      "invoices.field.amountMajor": "Amount ({currency})",
      "invoices.field.description": "Description",
      "invoices.amountTooSmall": "Enter an amount of at least {min} {currency}.",
      "invoices.willBill": "This will bill {amount}.",
      "invoices.willBillWithTax": "This will bill {amount} — {subtotal} plus {taxes}.",
      "invoices.willBillBeforeTax": "This will bill {amount} before tax.",
      "invoices.number.draft": "Draft",
      "invoices.receiptTag": "Receipt {number}",
      "invoices.status.refunded": "Refunded",
      "invoices.status.overdue_notified": "Overdue",
      "invoices.actions.cancel": "Cancel invoice",
      "invoices.confirmCancel": "Cancel invoice {number}? Its payment link stops working. The number stays assigned.",
      "invoices.confirmCancelDraft": "Cancel this draft invoice? It can no longer be sent.",
      "invoices.cancelled": "Invoice cancelled.",
      "invoices.error.notDeletable": "A numbered invoice cannot be deleted. Cancel it instead.",
      "invoices.error.notCancellable": "This invoice is already paid, refunded or cancelled.",
      "invoices.error.notSendable": "This invoice was paid or cancelled in the meantime.",
      "invoices.error.numberBusy": "Numbering is briefly unavailable, please retry.",
      "invoices.error.belowMinimum": "Card payments start at {min} {currency}, so this invoice cannot be sent. Delete it and create one for at least that amount.",
      "invoices.error.paymentsUnavailable": "Online payment is not available right now, so the invoice was not sent. Try again later.",
      "invoices.error.descriptionTooLong": "The description is longer than {max} characters, so this invoice cannot be sent. Delete it and create one with a shorter description.",
      "invoices.error.sentConcurrently": "This invoice was just sent from another window: only that payment link is valid.",
      "invoices.actions.send": "Send",
      "invoices.actions.copy_link": "Copy link",
      "invoices.status.draft": "Draft",
      "invoices.status.sent": "Sent",
      "invoices.status.paid": "Paid",
      "invoices.status.cancelled": "Cancelled",
      "invoices.empty": "No invoices yet."
  },
  "es": {
      "programs.title": "Programas",
      "programs.subtitle": "Crea y gestiona tus programas de acompañamiento.",
      "programs.new": "Nuevo programa",
      "programs.empty": "Sin programas todavía.",
      "programs.field.name": "Nombre del programa",
      "programs.field.tagline": "Subtítulo / eslogan",
      "programs.field.description": "Descripción completa",
      "programs.field.price": "Precio (en céntimos)",
      "programs.field.duration": "Duración (ej: 8 semanas)",
      "programs.field.image": "Imagen de portada",
      "programs.field.features": "Incluido en el programa",
      "programs.field.featured": "Destacar este programa",
      "programs.field.active": "Visible públicamente",
      "invoices.title": "Facturas",
      "invoices.subtitle": "Crea una factura, envía el enlace de pago Stripe por correo.",
      "invoices.new": "Nueva factura",
      "invoices.field.client_name": "Nombre del cliente",
      "invoices.field.client_email": "Correo del cliente",
      "invoices.field.amount": "Monto",
      "invoices.field.amountMajor": "Monto ({currency})",
      "invoices.field.description": "Descripción",
      "invoices.amountTooSmall": "Ingrese un monto de al menos {min} {currency}.",
      "invoices.willBill": "Se facturará {amount}.",
      "invoices.willBillWithTax": "Se facturará {amount} — {subtotal} más {taxes}.",
      "invoices.willBillBeforeTax": "Se facturará {amount} antes de impuestos.",
      "invoices.number.draft": "Borrador",
      "invoices.receiptTag": "Recibo {number}",
      "invoices.status.refunded": "Reembolsada",
      "invoices.status.overdue_notified": "Vencida",
      "invoices.actions.cancel": "Anular factura",
      "invoices.confirmCancel": "¿Anular la factura {number}? El enlace de pago dejará de funcionar. El número sigue asignado.",
      "invoices.confirmCancelDraft": "¿Anular este borrador de factura? Ya no se podrá enviar.",
      "invoices.cancelled": "Factura anulada.",
      "invoices.error.notDeletable": "Una factura numerada no se puede eliminar. Anúlala en su lugar.",
      "invoices.error.notCancellable": "Esta factura ya está pagada, reembolsada o anulada.",
      "invoices.error.notSendable": "Esta factura se pagó o anuló mientras tanto.",
      "invoices.error.numberBusy": "La numeración no está disponible por un momento, inténtalo de nuevo.",
      "invoices.error.belowMinimum": "Un pago con tarjeta debe ser de al menos {min} {currency}, así que esta factura no se puede enviar. Elimínala y crea una por al menos ese importe.",
      "invoices.error.paymentsUnavailable": "El pago en línea no está disponible en este momento, así que la factura no se envió. Inténtalo más tarde.",
      "invoices.error.descriptionTooLong": "La descripción supera los {max} caracteres, así que esta factura no se puede enviar. Elimínala y crea una con una descripción más corta.",
      "invoices.error.sentConcurrently": "Esta factura se acaba de enviar desde otra ventana: solo ese enlace de pago es válido.",
      "invoices.actions.send": "Enviar",
      "invoices.actions.copy_link": "Copiar enlace",
      "invoices.status.draft": "Borrador",
      "invoices.status.sent": "Enviada",
      "invoices.status.paid": "Pagada",
      "invoices.status.cancelled": "Cancelada",
      "invoices.empty": "Sin facturas todavía."
  },
};
